import * as FilePond from 'filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

var fileInput = {

	/**
	 * Init
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function(target) {

		fileInput.initEvents(target);
		fileInput.initFilepond(target);

	},

	/**
	 * Init events
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	initEvents: function(target) {

		target.addEventListener('click', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('body .form-fileinput [data-fileinput-remove]')) {
					fileInput.togglePlaceholder(event);
					break;
				}
			}
		}, false);

	},

	/**
	 * Toggle placeholder function
	 *
	 * @param {object} event
	 * @returns {void}
	 */
	togglePlaceholder: function(event) {
		let parent = event.target.closest('.form-fileinput');
		let placeholder = parent.querySelector('.form-fileinput-placeholder');
		let input = parent.querySelector('.form-fileinput-input');
		let validation = input.getAttribute('data-validate-org') || '';
		input.setAttribute('data-validate', validation);
		placeholder.classList.add('d-none');
		input.classList.remove('d-none');
	},

	/**
	 * Init Filepond
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	initFilepond: function(target) {

		setTimeout(function() {

			FilePond.registerPlugin(FilePondPluginFileValidateType);
			FilePond.registerPlugin(FilePondPluginFileValidateSize);

			var elements = target.querySelectorAll('input[type="file"].filepond');

			window.pond = [];

			elements.forEach(function(element, index) {

				var required = false;
				if (element.hasAttribute('data-validate') && (element.getAttribute('data-validate') == 'required')) {
					required = true;
				}

				var testId = false;
				if (element.hasAttribute('data-test-id')) {
					testId = element.getAttribute('data-test-id');
				}

				var acceptedFileTypes = ['image/*', 'application/pdf'];
				if (element.hasAttribute('data-filepond-accepted-filetypes')) {
					acceptedFileTypes = JSON.parse(element.getAttribute('data-filepond-accepted-filetypes'));
				}

				var fileEndpoint = element.getAttribute('data-file-endpoint');

				window.pond[index] = FilePond.create(element, {
					server: {
						process: fileEndpoint,
						revert: fileEndpoint,
						fetch: null
					},

					acceptedFileTypes: acceptedFileTypes,
					maxFileSize: '10MB',

					oninit() {
						var target = window.pond[index].element.querySelector('input[type="file"]');
						if (required) {
							target.setAttribute('data-validate', 'required');
						}
						if (testId) {
							target.setAttribute('data-test-id', testId);
						}
					},

					onprocessfile() {
						fileInput.onUpdate(index, required);
					},

					onremovefile() {
						fileInput.onUpdate(index, required);
					},

				});

				if (window.app.language != 'en_US') {
					FilePond.setOptions(fileInput.filepondLabelsNL);
				}

			});

		}, 100);

	},

	onUpdate: function(index, required) {
		var files = window.pond[index].getFiles();
		var target = window.pond[index].element.querySelector('input[type="file"]');
		if (!files.length) {
			if (required) {
				target.setAttribute('data-validate', 'required');
			}
		} else {
			if (required) {
				target.setAttribute('data-validate', '');
			}
			window.pond[index].element.closest('.form-group').classList.remove('has-error');
		}
	},

	/**
	 * Filepond NL Localisation
	 */
	filepondLabelsNL: {
		labelIdle: 'Sleep bestand hierheen of selecteer...',
		labelInvalidField: 'U heeft een bestandstype geselecteerd dat niet is toegestaan',
		labelFileWaitingForSize: 'Moment geduld a.u.b.',
		labelFileSizeNotAvailable: 'Bestandsgrootte niet te bepalen',
		labelFileLoading: 'Moment geduld a.u.b.',
		labelFileLoadError: 'Fout tijdens laden',
		labelFileProcessing: 'Bestand uploaden',
		labelFileProcessingComplete: 'Upload klaar',
		labelFileProcessingAborted: 'Upload afgebroken',
		labelFileProcessingError: 'Fout tijdens uploaden',
		labelTapToCancel: 'Afbreken',
		labelButtonRemoveItem: 'Verwijderen',
		labelButtonAbortItemLoad: 'Afbreken',
		labelButtonRetryItemLoad: 'Opnieuw',
		labelButtonAbortItemProcessing: 'Afbreken',
		labelButtonUndoItemProcessing: 'Ongedaan maken',
		labelButtonRetryItemProcessing: 'Normaals proberen',
		labelButtonProcessItem: 'Uploaden',
		labelMaxFileSizeExceeded: 'Bestand is te groot',
		labelMaxFileSize: 'Maximale bestandsgrootte: {filesize}',
		labelMaxTotalFileSizeExceeded: 'Maximaal aantal bestanden overschreden',
		labelMaxTotalFileSize: 'De maximale totale grootte is: {filesize}',
		labelFileTypeNotAllowed: 'Ongeldig bestandsformaat',
		fileValidateTypeLabelExpectedTypes: 'Werwacht {allButLastType} of {lastType}',
		imageValidateSizeLabelFormatError: 'Ongeldig bestandsformaat',
		imageValidateSizeLabelImageSizeTooSmall: 'Afbeelding is te klein',
		imageValidateSizeLabelImageSizeTooBig: 'Afbeelding is te groot',
		imageValidateSizeLabelExpectedMinSize: 'Minimaal formaat is: {minWidth} × {minHeight}',
		imageValidateSizeLabelExpectedMaxSize: 'Maximaal formaat is: {maxWidth} × {maxHeight}',
		imageValidateSizeLabelImageResolutionTooLow: 'Resolutie is te laag',
		imageValidateSizeLabelImageResolutionTooHigh: 'Resolutie is te hoog',
		imageValidateSizeLabelExpectedMinResolution: 'Minimale resolutie: {minResolution}',
		imageValidateSizeLabelExpectedMaxResolution: 'Maximale resolutie: {maxResolution}'
	}

};

export default fileInput;
